<template>
	<div class="icon-chevron-down">
		<svg
			width="18.000000"
			height="18.000000"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_1515">
					<rect
						id="Line/arrow-down-1"
						width="18.000000"
						height="18.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_1515)">
				<path
					id="path"
					d="M8.99 12.6C8.47 12.6 7.94 12.39 7.55 12L2.66 7.11C2.44 6.89 2.44 6.53 2.66 6.31C2.87 6.09 3.23 6.09 3.45 6.31L8.34 11.2C8.7 11.56 9.29 11.56 9.65 11.2L14.54 6.31C14.75 6.09 15.11 6.09 15.33 6.31C15.55 6.53 15.55 6.89 15.33 7.11L10.44 12C10.04 12.39 9.52 12.6 8.99 12.6Z"
					fill="#77797C"
					fill-opacity="1.000000"
					fill-rule="nonzero"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

export default class IconChevronDown extends Vue {}
</script>

<style scoped lang="scss"></style>
